"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateGuid = generateGuid;

/**
 * generate Guid
 *
 * @export func
 * @returns guid {string}
 */
function generateGuid() {
  var result = '';

  for (var j = 0; j < 32; j++) {
    if (j === 8 || j === 12 || j === 16 || j === 20) {
      result = result + '-';
    }

    var i = Math.floor(Math.random() * 16).toString(16).toUpperCase();
    result = result + i;
  }

  return result;
}